import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";

import Search from "../Search/Search";
import Title from "../../common/Title";
import BatchList from "../../common/BatchList";

import useBatchListState from "../../../hooks/useBatchListState";
import { CLIENTS } from "../../../constants/value";
import { OPERATIONS } from "../../../constants/value";
import { __getSimInfoBatches } from "../../../api/sim";

const SimInfo = ({ client }) => {
  const nav = useNavigate();

  const [searchActive, setSearchActive] = useState(false);

  const {
    data,
    loading,
    metaData,
    response,
    statusCategories,
    handlePageChange,
    handlePageSizeChange,
    handleStatusCategoryChange,
  } = useBatchListState(__getSimInfoBatches, { client });

  return (
    <Box sx={{ width: "100%" }}>
      <Title variant="h5" content="Sim Information" gutterBottom />
      <Search
        key={`${client}-sim_info`}
        client={client}
        operation={OPERATIONS.sim_info}
        searchActive={searchActive}
        setSearchActive={setSearchActive}
      />

      {!searchActive &&
        (response ? (
          <>
            <Grid container justifyContent="flex-start" spacing={2}>
              { ![CLIENTS.selectel, CLIENTS.opn, CLIENTS.it].includes(client) && (
                <Grid item>
                  {client === CLIENTS.ultra ? (
                    <Stack spacing={2} direction="row">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => nav("zip")}
                      >
                        Zip Check
                      </Button>
                    </Stack>
                  ) : (
                    <Stack spacing={2} mb={2} direction="row">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => nav("export")}
                      >
                        Export History
                      </Button>
                    </Stack>
                  )}
                </Grid>
              )}
              <Grid item>
                <Stack spacing={2} mb={2} direction="row">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => nav("form")}
                  >
                    Fetch Sim Info
                  </Button>
                </Stack>
              </Grid>
            </Grid>
            <BatchList
              data={data}
              loading={loading}
              meta={metaData}
              statusCategories={statusCategories}
              onStatusCategoryChange={handleStatusCategoryChange}
              handlePageChange={handlePageChange}
              handlePageSizeChange={handlePageSizeChange}
            />
          </>
        ) : (
          <Title content="Please wait..." variant="subtitle2" gutterBottom />
        ))}
    </Box>
  );
};

export default SimInfo;
